import React from 'react';
import { graphql, useFragment } from 'utils/graphClient';
import { OptionsMenuItem } from 'components/OptionsMenu/OptionsMenuItem';
import { MoveToFolderIcon } from 'components/icons';
import { t } from '@lingui/macro';
import { MoveFolderNodeModal } from '../../../Folder/MoveFolderNodeModal';
import { useDisclosure } from '@cardboard-ui/react';
import { MoveOption_node$key } from './__generated__/MoveOption_node.graphql';

const nodeFragment = graphql`
  fragment MoveOption_node on Node {
    __typename
    id
    ... on FolderNodeInterface {
      canMove {
        value
      }
      root: ancestors(last: 1) {
        edges {
          node {
            ... on Folder {
              id
            }
          }
        }
      }
    }
  }
`;

interface MoveFolderNodeOptionProps {
  node: MoveOption_node$key;
  connectionId?: string;
}

export const MoveOption = ({
  node: _node,
  connectionId,
}: MoveFolderNodeOptionProps) => {
  const { id, canMove, root } = useFragment(nodeFragment, _node);
  const { isOpen, onClose, onOpen } = useDisclosure();

  if (!canMove?.value) return null;

  const amountOfEdges = root?.edges?.length || 0;
  const rootFolderId = amountOfEdges > 0 && root?.edges[0].node?.id;

  if (!rootFolderId) return null;

  return (
    <>
      <OptionsMenuItem
        onClick={onOpen}
        icon={<MoveToFolderIcon />}
      >{t`Move to...`}</OptionsMenuItem>
      <MoveFolderNodeModal
        rootFolderId={rootFolderId}
        nodesBeingMovedIds={[id]}
        parentConnectionId={connectionId}
        isOpen={isOpen}
        onClose={onClose}
      />
    </>
  );
};
